import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from './services/shared.service';
import { UpdateService } from './services/update.service';
import { ActivityLoggerService } from './services/activityLogger.service';
import { AutoRefreshService } from './services/auto-refresh.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false
})

export class AppComponent implements OnInit {
  public currentLanguage?: string;
  public languages: string[] = ['fr', 'en'];
  public isBigRoute: boolean = false;

  constructor(private activityLogger: ActivityLoggerService, private translate: TranslateService, private sharedService: SharedService, private updateService: UpdateService, private refreshService: AutoRefreshService, private router: Router) {
    this.translate.addLangs(this.languages);
    this.translate.setDefaultLang('fr');
    this.sharedService.tokenConfig$.subscribe(config => {
      const lang = config?.displayLanguage;
      if (lang && lang !== this.currentLanguage) {
        this.currentLanguage = lang;
        this.translate.use(lang);
      }
    });
    this.sharedService.getConfiguration().subscribe(data => {
      this.setPiwik(data.piwikUrl, data.piwikSiteId);
    });
  }

  ngOnInit() {
    //this.refreshService.startAutoRefresh();
    console.log('AppComponent initialized');
    
    // Détecter les routes "big"
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event) => {
      this.isBigRoute = (event as NavigationEnd).url.includes('/big');
    });
    
    // Vérifier la route initiale
    this.isBigRoute = this.router.url.includes('/big');
  }

   // Example of manual error logging
  onCriticalError(error: any): void {
    this.activityLogger.logError('critical_application_error', JSON.stringify({
      errorType: 'critical',
      message: error.message,
      stack: error.stack,
      component: 'AppComponent'
    }));
  }

  private GetURLParameter(sParam: string) {
    const sPageURL = window.location.search.substring(1);
    const sURLVariables = sPageURL.split('&');
    for (let i = 0; i < sURLVariables.length; i++) {
      const sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0].toLocaleLowerCase() === sParam) {
        return sParameterName[1];
      }
    }
    return '';
  }

  private setPiwik(piwikUrl: string, piwikSiteId: number): void {
    const scriptElement: HTMLScriptElement = document.createElement('script');
    scriptElement.type = 'text/javascript';

    scriptElement.innerHTML = `var _paq = _paq || [];
  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);
  (function () {
      var u = "${piwikUrl}";
      _paq.push(['setTrackerUrl', u + 'piwik.php']);
      _paq.push(['setSiteId', '${piwikSiteId}']);
      var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
      g.type = 'text/javascript'; g.async = true; g.defer = true; g.src = u + 'piwik.js'; s.parentNode.insertBefore(g, s);
  })();`;

    document.head.appendChild(scriptElement);
  }
}
